import { Box, Typography, Avatar } from '@mui/material';
import { MessageRenderer } from '../messages/MessageRenderer';
import { Log } from '@fanfanlo';
import { IMatrixMessage } from '../../client';
import { roomData } from '../../client/room/data';
const fileLogger = new Log(false, 'im.components.room.MessageItem');
// fileLogger.childrenPaused = true;
// fileLogger.pause = true;
interface MessageItemProps {
  message: IMatrixMessage;
  currentUserId: string;
}

export function MessageItem({ message, currentUserId }: MessageItemProps) {
  const logger = fileLogger.sub(false, 'MessageItem_ui');
  logger.pause = true;
  logger.log('message=', message);
  logger.log('currentUserId=', currentUserId);

  // 获取成员信息
  let memberInfo = undefined;
  if (message.room_id && message.sender !== currentUserId) {
    const members = roomData.roomMembers[message.room_id] || [];
    memberInfo = members.find(m => m.userId === message.sender);
  }

  const isSelf = message.sender === currentUserId;

  if (isSelf) {
    // 自己的消息，右对齐，无头像无昵称
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          pb: 2
        }}
      >
        <Box
          sx={{
            maxWidth: '80%',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            p: 2,
            borderRadius: 2,
            boxShadow: 1,
            position: 'relative',
            wordBreak: 'break-word',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <MessageRenderer 
            message={message} 
            className={'sent-message'}
          />
          <Typography 
            variant="caption" 
            sx={{ 
              display: 'block',
              textAlign: 'right',
              mt: 0.5,
              opacity: 0.7,
              color: 'primary.contrastText'
            }}
          >
            {new Date(message.origin_server_ts).toLocaleTimeString()}
          </Typography>
        </Box>
      </Box>
    );
  }

  // 别人的消息，左侧头像，右侧昵称+消息气泡纵向排列
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        pb: 2
      }}
    >
      <Avatar
        src={memberInfo?.avatarUrl}
        alt={memberInfo?.displayName || message.sender}
        sx={{ width: 32, height: 32, mr: 1, mt: 0.5 }}
      >
        {(memberInfo?.displayName || message.sender)?.charAt(0) || '?'}
      </Avatar>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', maxWidth: '80%' }}>
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.75rem',
            color: 'text.secondary',
            maxWidth: 160,
            textAlign: 'left',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            lineHeight: 1.2,
            mb: 0.5,
          }}
          title={memberInfo?.displayName || message.sender}
        >
          {memberInfo?.displayName || message.sender}
        </Typography>
        <Box
          sx={{
            bgcolor: 'background.paper',
            color: 'text.primary',
            p: 2,
            borderRadius: 2,
            boxShadow: 1,
            position: 'relative',
            wordBreak: 'break-word',
            maxWidth: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <MessageRenderer 
            message={message} 
            className={'received-message'}
          />
          <Typography 
            variant="caption" 
            sx={{ 
              display: 'block',
              textAlign: 'right',
              mt: 0.5,
              opacity: 0.7,
              color: 'text.secondary'
            }}
          >
            {new Date(message.origin_server_ts).toLocaleTimeString()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}